import {
  Alert,
  GKSearchSelect,
  Grid2,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "components";
import { Controller, useFormContext } from "react-hook-form";
import { useAppSelector } from "store/store";

interface Props {
  fields: any[];
}

const BrokerCompanyMapping = (props: Props) => {
  const { fields } = props;

  const form = useFormContext();

  const userInfo = useAppSelector((state) => state?.user?.userData);
  const companies = useAppSelector((state) => state?.app?.companies);

  return (
    <TableContainer>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography fontSize={16}>Company Mapping</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Alert sx={{ mb: 2 }} severity="info">
                We couldn&#39;t find the following codes, please map them to the
                right companies.
              </Alert>
              {fields &&
                fields?.length !== 0 &&
                fields.map((item: any, index: number) => (
                  <Grid2 size={12} my={1} key={index}>
                    <Controller
                      name={`step3.company.${index}.value`}
                      control={form.control}
                      render={({ field }) => (
                        <GKSearchSelect
                          {...field}
                          disableClearable
                          renderOption={(props, option) => (
                            <li
                              {...props}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                              }}
                            >
                              <Typography
                                color={"var(--white)"}
                                fontSize={8}
                                style={{
                                  background:
                                    option?.instType === "EQ"
                                      ? "var(--secondary-900)"
                                      : "var(--orange-700)",
                                  padding: "2px 4px",
                                  borderRadius: 4,
                                }}
                              >
                                {option?.instType}
                              </Typography>
                              <Typography whiteSpace={"nowrap"}>
                                {option?.name}
                              </Typography>
                            </li>
                          )}
                          options={companies || []}
                          getOptionLabel={(option) =>
                            option?.companyName || option
                          }
                          inputLabel={item?.advisorCompany}
                          onChange={(e, val) => {
                            field.onChange(val?.value);
                            form.setValue(
                              `step3.company.${index}.nseBseCode`,
                              val.bse || val.nse,
                            );
                            form.setValue(
                              `step3.company.${index}.company`,
                              userInfo.companyId,
                            );
                          }}
                          value={
                            companies?.find(
                              (data: any) => data?.gridCode === field.value,
                            )?.companyName || ""
                          }
                        />
                      )}
                    />
                  </Grid2>
                ))}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BrokerCompanyMapping;
